<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="alertas.content"
      class="mt-8"
      :loading="loading"
      :server-items-length="alertas.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum alerta encontrado"
      loading-text="Carregando alertas..."
      :options="optionsList"
    >
      <template v-slot:item.oferta.titulo="{ item }">
        {{ item.oferta.titulo | truncate(40) }}
      </template>
      <template v-slot:item.createdIn="{ item  }">
        {{ item.createdIn | date(true) }}
      </template>
      <template v-slot:item.valor="{ item  }">
        {{ item.valor | currency }}
      </template>
      <template v-slot:item.precoAVista="{ item  }">
        {{ item.oferta.precoAVista | currency }}
      </template>
      <template v-slot:item.precoPromocaoAVista="{ item  }">
        {{ item.oferta.precoPromocaoAVista | currency }}
      </template>
      <template v-slot:item.options="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon
                   link
                   :to="`/marketplace/cadastro-oferta/${item.oferta.id}`"
                   target="_blank"
                   v-on="on">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar oferta</span>
        </v-tooltip>
        <px-open-oferta is-marketplace :oferta="item.oferta"/>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    alertas: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Oferta',
          value: 'oferta.titulo',
        },
        {
          text: 'Preço objetivo',
          value: 'valor',
        },
        {
          text: 'Preço à vista',
          value: 'precoAVista',
          sortable: false,
        },
        {
          text: 'Preço promocional',
          value: 'precoPromocaoAVista',
          sortable: false,
        },
        {
          text: 'Data de criação',
          value: 'createdIn',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    link() {
      return (item) => `/marketplace/ofertas/${item.oferta.id}`;
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
};
</script>
